import type { PointsHistoryEntry } from './points.schema';

const SOURCE_KEYS: Record<string, string> = {
  swap: 'referral.history.sourceSwap',
  limit_fill: 'referral.history.sourceLimit',
  vault_deposit: 'referral.history.sourceVault',
};

const EVENT_KEYS: Record<string, string> = {
  trade_executed: 'referral.history.sourceSwap',
  trade_referral: 'referral.history.sourceReferral',
  referral_attached: 'referral.history.sourceReferralAttached',
  limit_order_opened: 'referral.history.sourceLimitOpened',
  limit_order_filled: 'referral.history.sourceLimit',
  vault_deposited: 'referral.history.sourceVault',
  quest_completed: 'referral.history.sourceQuest',
  admin_adjustment: 'referral.history.sourceAdjustment',
  points_redeemed: 'referral.history.sourceRedeemed',
  points_redemption_refunded: 'referral.history.sourceRefunded',
};

export function historySourceKey(entry: PointsHistoryEntry): string {
  if (entry.source !== null) return SOURCE_KEYS[entry.source] ?? 'referral.history.sourceOther';
  if (entry.eventType.startsWith('quest_')) return 'referral.history.sourceQuest';
  return EVENT_KEYS[entry.eventType] ?? 'referral.history.sourceOther';
}

export function historyPointsLabel(entry: PointsHistoryEntry): string {
  return entry.deltaPoints > 0 ? `+${entry.deltaPoints}` : String(entry.deltaPoints);
}
